import { Component, OnInit } from '@angular/core';
import { BookingService } from '../../../../core/services/booking.service';
import { Options, LabelType } from 'ng5-slider';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NgbModal, NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
declare let gtag: (property: string, value: any, configs: any) => {};
@Component({
  selector: 'app-select-datetime',
  templateUrl: './select-datetime.component.html',
  styleUrls: ['./select-datetime.component.scss']
})
export class SelectDatetimeComponent implements OnInit {
  public plantsAndHours: any; // This will contain the available plants and its available hours to display
  public minHourRestrict: number;
  public minHour: string;
  public maxHour: string;
  public minValue: number; // Min hour displayed in ng5-slider
  public maxValue: number; // Max hour displayed in ng5-slider
  public nextHours: any = [];
  public daysFilter: string;
  public hourSelected: string = '';
  public plantSelected: string = 'Lugar sin seleccionar';
  public dateSelected: string = '';
  public dateSelectedNotFormat: string = '';
  public hourSelectedNotFormat: string = 'Hora sin seleccionar';
  public addressSelected: string = '';
  public patent: string;
  public title: string;
  public btnDatetime = 1;
  public isClicked = [];
  public myVar: boolean = false;
  public reference = '';
  public zoom: number = 13;
  public lat: number = -33.4942075;
  public lng: number = -70.6355676;
  public myMaps: boolean = false;
  public arrows: any;
  public codePlant: string;
  public latitude: string;
  public longitude: string;
  public myMoment: string;
  model: NgbDateStruct;
  public markDisabled;
  public arraylleno: boolean = false;

  // Ng-slider configuration
  options: Options = {
    translate: (value: number, label: LabelType): string => {
      if (value === 12) {
        return '12:00 P.M.';
      } else if (value === 13) {
        return '1:00 P.M.';
      } else if (value === 14) {
        return '2:00 P.M.';
      } else if (value === 15) {
        return '3:00 P.M.';
      } else if (value === 16) {
        return '4:00 P.M.';
      } else if (value === 17) {
        return '5:00 P.M.';
      } else if (value === 18) {
        return '6:00 P.M.';
      } else if (value === 19) {
        return '7:00 P.M.';
      } else if (value === 20) {
        return '8:00 P.M.';
      } else if (value === 21) {
        return '9:00 P.M.';
      } else if (value === 22) {
        return '10:00 P.M.';
      } else if (value === 23) {
        return '11:00 P.M.';
      }
      return value + ':00 A.M.';
    },
  };

  /* Ngb-datepicker properties */
  outsideDays;
  minimumDate;
  maximumDate;
  disabledDays;

  constructor(
    private bookingService: BookingService,
    private route: Router,
    private ngxService: NgxUiLoaderService,
    private modalService: NgbModal,
    private location: Location,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.setCalendarConfig();
    this.verifyBooking();
    this.loadDate();
  }

  public getAvailabilityinNextMonth(month, year){
    var init_date = `${month}-01-${year}`;
    var end_date = `${month}-31-${year}`;
    var daysInMonth = new Date(year, month, 0).getDate();
    this.bookingService.getAvailabilityByPlantAndMonth(init_date, end_date).subscribe((response) =>{
      if(response.message && response.status){
        this.maximumDate = { year: year, month: month, day: daysInMonth };
      }
    });
  }
  public getCalendarAvailability(event){
    const month = event.month;
    const year = event.year;
    this.bookingService.getCalendarAvailability(month, year).subscribe((response) =>{
      if(response.message && response.status){
        this.disabledDays = (date: NgbDate) => {
          const d = new Date(date.year, date.month - 1, date.day);
          return !(response.message.find(x => x.day === (moment(d)).format('YYYY-MM-DD')) !== null  && response.message.find(x => x.day === (moment(d)).format('YYYY-MM-DD')) !== undefined); 
        };
        if(response.message.length > 0){
          let firstAvailabilityDay = new Date(response.message[0].day);
          this.model = { year: year, month: month, day: firstAvailabilityDay.getDate() + 1 };
        }
        else{
          this.toastr.error("Agenda No disponible");
        }
      }
      this.ngxService.stop();
    });
  }
  /* This sets the initial calendar configuration > No sundays and min/max date range */
  public setCalendarConfig() {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    const lastDate = new Date(year, month, 0);
    this.minimumDate = { year, month, day }; // Minimum available date
    this.maximumDate = { year: year, month: month, day: lastDate.getDate() }; // Maximum available date
    this.outsideDays = 'hidden';

    // sundays are disabled
    this.disabledDays = (date: NgbDate) => {
      const d = new Date(date.year, date.month - 1, date.day);
      return d.getDay() === 0;
    };
  }

  /* Verifies where the booking operation comes from */
  async verifyBooking() {
    await this.bookingService.getDataChangeBooking().toPromise().then(
      (response) => this.patent = response.patent
    );
    this.title = this.patent === undefined ? 'Agendar reserva' : 'Reagendar reserva';
  }

  /* Gets the available plants and its available hours */
  loadDate() {
    const date = new Date();
    let testMinHour: number = 0;
    let testMaxHour: number = 0;

    this.bookingService.getDate().subscribe((response) => {
      this.dateSelectedNotFormat = this.convertStringToFomart(response);
      this.dateSelected = response;
      this.takeDays();
      if (this.dateSelected === undefined) {
        this.route.navigateByUrl('/');
      } else {

        /* Gets the available bookings */
        this.bookingService.getAvailability().subscribe((res) => {
          const availablePlants = JSON.parse(res);

          const preProcessedPlants = availablePlants.map(plant => {
            plant.init_hour = '';
            return plant;
          });

          //Acá resolví el tema de la inconsistencia de horas por planta(llamé al servicio de plantas con el nombre)
          //Filtro por plantas
          preProcessedPlants.forEach((plant, index) => {
            this.bookingService.getBookingAvailabilityByPlant(this.dateSelected, plant.plant)
              .subscribe(hoursByPlant => {
                plant.rangeOfHours = hoursByPlant.message[0].rangeOfHours.filter(hour => hour.totalForReservation > hour.reservated);
                plant.rangeOfHours = plant.rangeOfHours.filter(hour => this.filterHours(hour, plant));
                this.sortByHour(plant.rangeOfHours)
                this.setFirstAvailableHour(plant.rangeOfHours, index);
              });
          });
          
          this.daysFilter = preProcessedPlants;
        });
        this.maxValue = +this.convertSecondsToHour(testMaxHour); // Parse to int (parseInt(varToParse) equivalent)
        this.minHourRestrict = +this.convertSecondsToHour(testMinHour); // Parse to int (parseInt(varToParse) equivalent)
        // Asigns the min and max value to the ng-slider options
        this.options = Object.assign({},
          this.options, { minLimit: this.minHourRestrict },
          this.options.floor = this.minHourRestrict,
          this.options.ceil = this.maxValue
        );
        if (moment(response, 'YYYY-MM-DD').format() > moment(date, 'YYYY-MM-DD').format()) {
          this.minHour = this.minHourRestrict <= 9 ? `0${this.minHourRestrict}:00` : `${this.minHourRestrict}:00`;
          this.minValue = this.minHourRestrict;
        } else {
          this.minHourRestrict = new Date().getHours() + 1;
          this.options = Object.assign({}, this.options, { minLimit: this.minHourRestrict });
          this.minHour = this.minHourRestrict <= 9 ? `0${this.minHourRestrict}:00` : `${this.minHourRestrict}:00`;
          this.minValue = this.minHourRestrict;
        }
        this.generatePreBooking(this.minValue, this.maxValue);
      }
    });
  }

  setFirstAvailableHour(hours: any[], index: number) {
    const firstAvailableHour = hours.find(this.hasAvailability);
    const hour = (firstAvailableHour !== undefined) ? firstAvailableHour.hour : '';
    this.plantsAndHours[index].init_hour = hour;
    this.plantsAndHours[index].end_hour = hour;
  }

  onUserChangeEnd(): void {
    this.plantSelected = 'Lugar sin seleccionar';
    this.hourSelectedNotFormat = 'Hora sin seleccionar';
    this.addressSelected = '';
    this.hourSelected = '';
    this.btnDatetime = 1;
    this.myVar = false;
    this.minHour = this.minValue <= 9 ? `0${this.minValue}:00` : `${this.minValue}:00`;
    this.maxHour = this.maxValue <= 9 ? `0${this.maxValue}:00` : `${this.maxValue}:00`;
    this.generatePreBooking(this.minValue, this.maxValue);
  }

  /* This sets the arrays that contains all the plant and its available hours */
  generatePreBooking(minHour, maxHour) {
    //this.arraylleno = false;
    const currentDate = new Date();
    let minutes = currentDate.getMinutes().toString();
    const hourfilter = (currentDate.getHours() + 1).toString();
    minutes = +minutes <= 9 ? `0${minutes}` : minutes;
    if (this.daysFilter !== undefined) {
      //this.plantsAndHours = JSON.parse(this.daysFilter);
      this.plantsAndHours = this.daysFilter;
      if (+hourfilter === minHour) {
        if (moment(this.dateSelected, 'YYYY-MM-DD').format() > moment(currentDate, 'YYYY-MM-DD').format()) {
          minHour = minHour <= 9 ? `0${minHour}::00` : `${minHour}::00`;
        } else {
          minHour = minHour <= 9 ? `0${minHour}:${minutes}` : `${minHour}:${minutes}`;
        }
        if (maxHour <= 9) {
          this.maxHour = '0' + maxHour + ':00';
          maxHour = '0' + maxHour + ':00';
        } else {
          maxHour = maxHour + ':00';
          this.maxHour = maxHour + ':00';
        }
      } else {
        minHour = minHour <= 9 ? `0${minHour}:00` : `${minHour}:00`;
        if (maxHour <= 9) {
          this.maxHour = '0' + maxHour + ':00';
          maxHour = '0' + maxHour + ':00';
        } else {
          maxHour = maxHour + ':00';
          this.maxHour = maxHour + ':00';
        }
      }

      // Iterate every plant ...

        const availableHours = [];
        
        //Filtro por día
        this.plantsAndHours.forEach((plant, index) => {
          plant.rangeOfHours = plant.rangeOfHours.filter(hour => this.filterHours(hour, plant))
        });
        
    }
  }

  //Con este filtro me aseguro de que tanto en la busqueda por plantas como en la busqueda por días 
  //siempre obtenga la misma información
  filterHours(hour, plant) {  
    return this.isVisible(plant.end_date, hour.hour);
  }

  /* New function time hour visible*/
  isVisible(initDate:string, backendTime:string){
    const currentDate = moment(initDate).format("YYYY-MM-DD");
    const currentBackendDateTime = moment(currentDate + " " + backendTime);    
    const currentDateTime = moment();
    const diff = currentDateTime.diff(currentBackendDateTime);

    return diff < 0;
  }

  hasAvailability(hour) {
    return hour.reservated < hour.totalForReservation;
  }
  
  takeDays() {
    const date = moment(this.dateSelected, 'YYYY-MM-DD').format();
    const now = new Date(date);
    this.model = {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      day: now.getDate(),
    };
  }

  takeHour(plant, hour, address, reference, codePlant, latitude, longitude) {
    this.isClicked = [];
    this.hourSelected = hour;
    this.plantSelected = plant;
    this.addressSelected = address;
    this.reference = reference;
    this.codePlant = codePlant;
    this.latitude = latitude;
    this.longitude = longitude;
    //this.hourSelectedNotFormat = moment(hour, ['H:mm']).format('h:mm A');
    this.hourSelectedNotFormat = hour;
    this.btnDatetime = 0;
    this.myVar = true;
  }

  convertHourToSeconds(hour) {
    return (+hour.split(':')[0]) * 60 * 60 + (+hour.split(':')[1]) * 60;
  }

  convertSecondsToHour(seconds, format = 'H') {
    return moment().startOf('day')
      .seconds(seconds)
      .format(format);
  }

  preBooking() {
    if (this.hourSelected !== '') {
      this.ngxService.start();
      gtag('event', 'Reserva9OReagenda4', {'event_category': 'Reserva9OReagenda4', 'Reserva9OReagenda4': 'Reserva9OReagenda4', 'value': 'Reserva9OReagenda4'});
      this.bookingService.savePreBooking(
        this.dateSelected,
        this.hourSelected,
        this.plantSelected,
        this.addressSelected,
        this.reference,
        this.codePlant,
        this.latitude,
        this.longitude
      ).subscribe((response) => {
        this.ngxService.stop();
        if (response.status) {
          this.route.navigateByUrl('/booking/personal-information');
        }
      });
    }
  }

  navigatorBack() {
    this.location.back();
  }

  convertStringToFomart(dt, format = 'DD MMMM YYYY') {
    moment.locale('es-es');
    return moment.utc(dt).format(format);
  }

  cancelSelect() {
    this.plantSelected = 'Lugar sin seleccionar';
    this.hourSelectedNotFormat = 'Hora sin seleccionar';
    this.addressSelected = '';
    this.hourSelected = '';
    this.btnDatetime = 1;
    this.myVar = false;
    this.isClicked = [];
  }

  seeMaps() {
    this.myMaps = !this.myMaps;
  }

  hiddenMaps() {
    this.myMaps = false;
  }

  /* Modal */
  openModal(content) {
    this.ngxService.start();
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true });
  }
  /* Disables holydays and looks for availability of booking for rfest of the days */
  pickUpDate(event) {
    this.ngxService.start();
    var month = event.month + 1;
    var year = event.year;
    if(month > 12){
      month = 1;
      year += 1; 
    }
    this.getAvailabilityinNextMonth(month, year);
    this.getCalendarAvailability(event);
  }

  /* Disable days based on the ms mandatory returned days */
  public isDisabled(availableDays, year, month) {
    const daysOfMonth = new Date(year, month, 0).getDate(); // This returns the total days of the month (number)
    const disabledDates: NgbDateStruct[] = [];
    /* This finds and push to the disabled days all sundays */
    for (let i = 0; daysOfMonth >= i; i++) {
      const date = new Date(year, month - 1, i);
      if (date.getDay() === 0) {
        disabledDates.push({ year, month, day: date.getDate() });
      }
    }
    /* This looks for all holydays that comes in the not-worked-days service */
    availableDays.message.days.forEach(element => {
      disabledDates.push({ year, month, day: element.day });
    });
    /* Then the disabled days are set */
    this.disabledDays = (dateStruct: NgbDateStruct) => {
      return disabledDates.find(date => new NgbDate(date.year, date.month, date.day).equals(dateStruct));
    };
  }

  updateDate() {
    if (this.model !== undefined) {
      this.ngxService.start();
      const date = (this.model.year + '-' + this.model.month + '-' + this.model.day);
      this.myMoment = moment.utc(date, 'YYYY-MM-DD').format();
      this.bookingService.getBookingAvailability(this.myMoment).subscribe(
        response => {
          this.ngxService.stop();
          if (response.status) {
            this.bookingService.setAvailability(response.message);
            this.loadDate();
          }
        },
        error => this.ngxService.stop()
      );
    }
  }

  /* Sort the rangeOfHours from a service by hour */
  sortByHour(rangeOfHours: Array<any>) {
    rangeOfHours.sort((a, b) => {
      const dateA = moment(a.hour, 'HH:mm');
      const dateB = moment(b.hour, 'HH:mm');
      if (dateA < dateB) {
        return -1;
      }
      if (dateA > dateB) {
        return 1;
      }
      return 0;
    });
  }
}
